<div>
  <div class="d__flex just-s">
    <h6>Edit Variant</h6>
    <div>
      <ion-button fill="clear"  class="ion-text-capitalize" size="small" (click)="modalCtrl.dismiss()"> Close</ion-button>
      <ion-button fill="clear"  class="ion-text-capitalize" size="small" (click)="save_value()">Save</ion-button>
    </div>
  </div>

  <div class="variants__container d__flex" *ngIf="product_info">
    <div class="side-1" >
      <div class="d__flex">
        <div class="image-container">
          <img [src]="db.product_img(product_info.image)" alt="">
        </div>
        <div>
          <h6 class="m-0">{{product_info.item}}</h6>
          <p> {{product_info.product_variant.length}} Variant</p>
        </div>
      </div>
      <div class="combinations">
        <h6>Combinations</h6>
        <div *ngFor="let item of product_info.product_variant" class="d__flex just-s" (click)="load_values(item)">
          <div class="fnt-14" [innerHTML]="item.attribute_html"></div>
          <div>Stock : {{item.stock}}</div>
        </div>
      </div>
    </div>
    <div class="side-2">
      <div>
        <h5>VARIANT DETAIL</h5>
        <div class="myform gap-10 d__flex flex-w">
          <div class="input-box" *ngFor="let item of form_data[0].group_fileds">
            <div [title]="item.name" class="m-0 label position-relative d__flex ion-align-items-center" (mouseenter)="item.show_info = true" (mouseleave)="item.show_info = false" (click)="item.input_type == 'checkbox' ?item.value = !item.value:null">
              <span class="op-7"> {{item.label}} </span>    
             </div>
            <ion-input *ngIf="item.input_type == 'input'" [name]="item.name" [type]="item.type" [(ngModel)]="current_variant[item.name]" [placeholder]="item.placeholder" [required]="item.required" [email]="item.validator == 'email'" [pattern]="item.pattern" [value]="item.value" (ionFocus)="item.focus = true" (ionBlur)="item.focus = false" [class.focus]="item.focus"></ion-input>
          </div>
        </div>
        <!-- <app-dynamic-form [myform]="myform" [form_data]="form_data" [current_value]="'variant_detail'"></app-dynamic-form> -->
        <!-- <ion-button >Save</ion-button> -->
      </div>
      <div>
        <img src="">
      </div>

    </div>
  </div>

</div>
